import { render, staticRenderFns } from "./SendItemDialog.vue?vue&type=template&id=52d0d5aa"
import script from "./SendItemDialog.vue?vue&type=script&lang=ts"
export * from "./SendItemDialog.vue?vue&type=script&lang=ts"
import style0 from "./SendItemDialog.vue?vue&type=style&index=0&id=52d0d5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports